export function getIsAbleEditGoods(assignOrderItem, orderStatus) {
  // 订单未完成指认
  const isNotFinishAssigning = assignOrderItem.findIndex(item => item.status === 2) === -1
  // 订单处于活跃状态
  const isActiveStatus = !['WAITING_PAY', 'CANCEL'].includes(orderStatus)
  return isNotFinishAssigning && isActiveStatus
}
